export default {
  data: () => ({
    windowWidth: 0,
  }),
  created() {
    if (process.env.VUE_ENV === 'client') {
      this.windowResized();
    }
  },
  mounted() {
    if (process.env.VUE_ENV === 'client') {
      window.addEventListener('resize', this.windowResized);
    }
  },
  beforeDestroy() {
    if (process.env.VUE_ENV === 'client') {
      window.removeEventListener('resize', this.windowResized);
    }
  },
  methods: {
    windowResized() {
      this.windowWidth = window.innerWidth;
    },
  },
  computed: {
    /**
     * Compute the current window size breakpoint given the window's current size
     */
    windowSize() {
      if (this.windowWidth >= 1200) {
        return 'XL';
      } else if (this.windowWidth >= 992) {
        return 'LG';
      } else if (this.windowWidth >= 768) {
        return 'MD';
      } else if (this.windowWidth >= 576) {
        return 'SM';
      } else {
        return 'XS';
      }
    },
    isWindowSM() {
      return [ 'SM', 'MD', 'LG', 'XL' ].includes(this.windowSize);
    },
    isWindowMD() {
      return [ 'MD', 'LG', 'XL' ].includes(this.windowSize);
    },
    isWindowLG() {
      return [ 'LG', 'XL' ].includes(this.windowSize);
    },
    isWindowXL() {
      return [ 'XL' ].includes(this.windowSize);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/grid.js